module.exports = __webpack_public_path__ + "img/4_114.5a21e62f.png";